import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56c5bfb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-center-card flex items-center justify-center flex-col p-6 shadow rounded-2xl relative" }
const _hoisted_2 = {
  key: 0,
  class: "absolute top-6 right-6 bg-sienna-500 text-sm font-semibold text-white py-1 px-3 rounded-full leading-5"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_5 = {
  key: 1,
  class: "flex items-center gap-2 mt-2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "12",
  height: "13",
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.87497 4.94589V3.14587C2.87497 1.48897 4.27407 0.145996 6 0.145996C7.72593 0.145996 9.12503 1.48907 9.12503 3.14587V4.94589C10.1606 4.94589 11 5.75179 11 6.74592V10.346C11 11.3402 10.1606 12.146 9.12503 12.146H2.87497C1.83945 12.146 1 11.3402 1 10.346V6.74592C1 5.75179 1.83945 4.94589 2.87497 4.94589ZM7.87497 4.94589V3.14587C7.87497 2.15174 7.03552 1.34584 6 1.34584C4.96448 1.34584 4.12503 2.15174 4.12503 3.14587V4.94589H7.87497ZM6 7.34599C6.34518 7.34599 6.62495 7.61458 6.62495 7.94597V9.14602C6.62495 9.4774 6.34518 9.746 6 9.746C5.65482 9.746 5.37505 9.4774 5.37505 9.14602V7.94597C5.37505 7.61458 5.65482 7.34599 6 7.34599Z",
    fill: "#E37056"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-neutral-700" }, "Cơ sở đang khoá", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dataOrg.is_new)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Mới "))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'opacity-30': !_ctx.dataOrg.is_active_org }, "mb-1.5"])
    }, [
      (_ctx.dataOrg?.profile_photo?.w200)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "shadow-sm inline-block h-16 w-16 rounded-2xl",
            src: _ctx.dataOrg?.profile_photo?.w200,
            alt: ""
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "inline-flex items-center justify-center h-16 w-16 rounded-2xl",
            style: _normalizeStyle({
					background: _ctx.dataOrg?.profile_photo?.default?.color,
				})
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.dataOrg?.profile_photo?.default?.initial), 1)
          ], 4))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'opacity-30': !_ctx.dataOrg.is_active_org }, "name font-semibold text-neutral-700 text-center mb-auto"])
    }, _toDisplayString(_ctx.dataOrg.name), 3),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'opacity-30': !_ctx.dataOrg.is_active_org }, "text-sm text-neutral-700 text-center mb-1.5 text-center"])
    }, _toDisplayString(_ctx.dataOrg.address), 3),
    _createElementVNode("div", {
      class: _normalizeClass([{ 'opacity-30': !_ctx.dataOrg.is_active_org }, "text-sm text-neutral-700 font-semibold text-center"])
    }, _toDisplayString(_ctx.dataOrg.city), 3),
    (!_ctx.dataOrg.is_active_org)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "button-p text-center mt-6",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
    }, " Chọn cơ sở ")
  ]))
}